// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const heatmor: PokeData = {
  "id": 631,
  "name": "heatmor",
  "height": 14,
  "weight": 580,
  "base_experience": 169,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "bind",
    "tackle",
    "flamethrower",
    "fire-spin",
    "lick",
    "amnesia",
    "fury-swipes",
    "slash",
    "stockpile",
    "spit-up",
    "swallow",
    "snatch",
    "odor-sleuth",
    "flare-blitz",
    "bug-bite",
    "hone-claws",
    "flame-burst",
    "incinerate",
    "inferno",
    "fire-lash"
  ],
  "moves": [
    "tackle",
    "flamethrower",
    "fire-spin",
    "lick",
    "snatch",
    "flare-blitz",
    "bug-bite",
    "magma-storm",
    "fire-punch",
    "fire-ball",
    "morning-sun",
    "ember",
    "fire-fang"
  ],
  "evolution_chain": {
    "id": 321,
    "item": null,
    "species": [
      {
        "name": "heatmor",
        "order": 632,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 106,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
